// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaItemBrands.MaxaItemBrands.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MaxaItemBrands/SuiteScript2/MaxaItemBrands.Service.ss"
            ),
            true
        )
});
});
